import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

var StorybookAnalytics = /*#__PURE__*/function () {
  function StorybookAnalytics(actionFunction) {
    _classCallCheck(this, StorybookAnalytics);

    this.actionFunction = actionFunction("Analytics event");
  }

  _createClass(StorybookAnalytics, [{
    key: "sendEvent",
    value: function sendEvent(category, action, label) {
      this.actionFunction("Category: ".concat(category), "Action: ".concat(action), "Label: ".concat(label));
    }
  }]);

  return StorybookAnalytics;
}();

export default StorybookAnalytics;